export default ({
  afterSubmit,
  allowEmpty,
  allowNull,
  alwaysOn,
  basePath,
  beforeSubmit,
  component,
  data,
  defaultValue,
  error,
  format,
  formatOnBlur,
  formClassName,
  initializeForm,
  input,
  isEqual,
  isRequired,
  label,
  limitChoicesToValue,
  locale,
  margin,
  meta,
  multiple,
  name,
  options,
  optionText,
  optionValue,
  parse,
  record,
  ref,
  render,
  resource,
  source,
  submitError,
  subscription,
  textAlign,
  translate,
  translateChoice,
  type,
  validate,
  validateFields,
  value,
  variant,
  ...rest
}: any) => rest;
